import {
  GET_FINANCE_LIST,
  DELETE_FINANCE,
  ADD_FINANCE,
  UPDATE_FINANCE,
  SET_CURRENT_FINANCE,
  CLEAR_CURRENT_FINANCE,
  SET_FILTER_TYPE_FINANCE,
} from '@jumbo/constants/ActionTypes';

const INIT_STATE = {
  shortFinanceList: [],
  shortFinance: {},
  currentShortFinacne: null,
  metaPayofflist: null,
  currentPayoff: null,
  financeFilter: {
    by_user_name: '',
    page: 1,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FINANCE_LIST:
      return {
        ...state,
        shortFinanceList: action.payload.pay_offs,
        metaPayofflist: action.payload.meta,
      };

    case DELETE_FINANCE: {
      return {
        ...state,
        shortFinanceList: state.shortFinanceList.filter(item => item.id !== action.payload),
      };
    }

    case ADD_FINANCE:
      return {
        ...state,
        shortFinanceList: state.shortFinanceList.concat(action.payload),
      };

    case UPDATE_FINANCE:
      return {
        ...state,
        shortFinanceList: action.payload,
      };

    case SET_CURRENT_FINANCE:
      return {
        ...state,
        currentPayoff: action.payload,
      };

    case CLEAR_CURRENT_FINANCE:
      return {
        ...state,
        currentPayoff: null,
      };

    case SET_FILTER_TYPE_FINANCE:
      return {
        ...state,
        financeFilter: action.payload,
      };

    default:
      return state;
  }
};
